// extracted by mini-css-extract-plugin
export default {"info_modal_content":"BaseResponseModal_info_modal_content__6ZxMf"};